
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/buySell",
      function () {
        return require("private-next-pages/account/buySell/index.p.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/buySell"])
      });
    }
  